import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-trash",
  "use": "icon-trash-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 15 15\" id=\"icon-trash\">\r\n  <image id=\"icon-trash_删除\" width=\"15\" height=\"15\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAApElEQVQokWP8//8/AwwYGpk0MTAw6DHgBpfOnztTB5NF0UwqYDQwNN7EwMDAR4beTxTZzMQA8aufoZGJBpLfa5EVIfNB6gyNTELhmhkYGJQYGBgkkNQ7o1mCzAep00bWTL6zRzWDwT8CfLyaYwjwUTS/g8UdCJw/d+YZsiI0PkjdfRCDBSqwkoGBYYmhkYkXAwPDb1x+ZGBgYGVgYPgGdgkDAwMA9DMmydd5is0AAAAASUVORK5CYII=\"></image>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/trash.svg
// module id = 9CsS
// module chunks = 127